import styled from "styled-components";

export const TitleText = styled.h1`
  color: ${(props) => props.theme.textPrimary};
  font-size: 3em;
  text-align: center;
  margin-top: 2rem;
`;
